window.WolforkQuizApi = {
  async saveDogs({ dogs, version = 1 }) {
    const res = await fetch('/apps/wolfork-quiz/save-dogs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ version, dogs }),
    });
    const body = await res.json().catch(() => ({}));
    return { ok: res.ok && body.ok, status: res.status, body };
  },

  async saveLead({ email, dogs, consent = false, version = 1 }) {
    const res = await fetch('/apps/wolfork-quiz/save-lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, dogs, consent, version }),
    });
    const body = await res.json().catch(() => ({}));
    return { ok: res.ok && body.ok, status: res.status, body };
  },

  /**
   * Shopify-klant met marketing-consent + tag via het native newsletterformulier
   * (/contact, form_type=customer). Shopify eist daar een hCaptcha-token; een los
   * fetch-verzoek krijgt "Missing CAPTCHA token". Daarom een verborgen formulier dat
   * Shopify.captcha.protect() koppelt: na het (onzichtbare) token roept Shopify
   * form.submit() aan, dat we hier als fetch versturen zodat de pagina blijft staan.
   * Vraagt Shopify een zichtbare challenge, dan vervalt alleen de tag (consent zet de Worker).
   */
  subscribeLead({ email, tags = 'quiz', timeoutMs = 8000 }) {
    return new Promise((resolve) => {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = '/contact';
      form.acceptCharset = 'UTF-8';
      form.hidden = true;
      [['form_type', 'customer'], ['utf8', '✓'], ['contact[email]', email], ['contact[tags]', tags]].forEach(([name, value]) => {
        form.append(Object.assign(document.createElement('input'), { type: 'hidden', name, value }));
      });

      let settled = false;
      const finish = (result) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        form.remove();
        resolve(result);
      };
      const timer = setTimeout(() => finish({ ok: false, reason: 'timeout' }), timeoutMs);

      form.submit = () => {
        fetch('/contact', { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
          .then((res) => finish({ ok: res.ok && !res.url.includes('/challenge'), status: res.status, url: res.url }))
          .catch((error) => finish({ ok: false, error }));
      };

      document.body.append(form);
      const captcha = window.Shopify && window.Shopify.captcha;
      if (!captcha || !captcha.protect) {
        form.submit();
        return;
      }
      captcha.protect(form);
      const waitForBinding = () => {
        if (settled) return;
        if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound) {
          form.requestSubmit();
          return;
        }
        setTimeout(waitForBinding, 100);
      };
      waitForBinding();
    });
  },

  /**
   * Quizresultaat naar Klaviyo via de Client API: publieke sleutel (site ID), geen
   * cookies of onsite-script nodig. Het event "Quiz Voltooid" zet ook de
   * profieleigenschappen. Klaviyo negeert een tweede event met dezelfde unique_id
   * voor hetzelfde profiel, dus herladen van de resultaatpagina telt niet dubbel.
   */
  async trackQuizCompleted({ email, uniqueId, eventProperties, profileProperties }) {
    const res = await fetch('https://a.klaviyo.com/client/events?company_id=WhsMgG', {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: eventProperties,
            unique_id: uniqueId,
            metric: { data: { type: 'metric', attributes: { name: 'Quiz Voltooid' } } },
            profile: { data: { type: 'profile', attributes: { email, properties: profileProperties } } },
          },
        },
      }),
    });
    return { ok: res.status === 202, status: res.status };
  },

  async deleteDog({ dogId }) {
    const res = await fetch('/apps/wolfork-quiz/delete-dog', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dogId }),
    });
    const body = await res.json().catch(() => ({}));
    return { ok: res.ok && body.ok, status: res.status, body };
  },
};
